export const loadIconsSet = (iconSet: 'filled' | 'outlined' | 'two-tone') => {
    if (iconSet) {
        if(iconSet !== 'filled' && iconSet !== 'outlined' && iconSet !== 'two-tone') {
            console.warn('Invalid icon set requested:', iconSet);
            return;
        }
        const linkId = `materialIconsStyle${iconSet}`;
        if (document.getElementById(linkId)) {
            return;
        }
        const link = document.createElement('link');
        const suffixes = {
            'outlined': '+Outlined',
            'two-tone': '+Two+Tone',
            'filled': ''
        };
        link.rel = 'stylesheet';
        link.id = `materialIconsStyle${iconSet}`;
        link.type = 'text/css';
        link.href = `https://fonts.googleapis.com/icon?family=Material+Icons${suffixes[iconSet]}`;
        document.head.appendChild(link);
    }
}
